import { s as p, r as m, a as x, f as g, b as C, Q as F } from "./themes-5f0b3c3d.mjs";
import { f as b } from "./fontWeights-a25f8f91.mjs";
import { l as y } from "./lineHeights-72d3110c.mjs";
import "react/jsx-runtime";
import "react";
const S = {
  categorical: [
    "#066FEF",
    "#00095B",
    "#6B7786",
    "#004F54",
    "#E67205",
    "#DB199A",
    "#6B2EAA",
    "#6B1705"
  ],
  blue: ["#033878", "#0559BF", "#066FEF", "#1F7DF1", "#388CF2"],
  gray: ["#00142E", "#1F3047", " #38485C", "#4D5B6D", "#6B7786"],
  red: ["#6B1705", "#AB2408", "#D62D0A", "#DA4223", "#DE573B"],
  orange: ["#612004", "#86350A", "#A84A0E", "#C85E0E", "#E67205"],
  green: ["#004100", "#006800", "#008200", "#198F19", "#339B33"],
  teal: ["#003F54", "#085A6E", "#0C7483", "#088D95", "#00A5A5"],
  magenta: ["#4B0735", "#7F165B", "#B11C7E", "#DB199A", "#F644BB"],
  purple: ["#50098E", "#6B2EAA", "#8746C6", "#A15BE0", "#BB6FF9"],
  bad2good: ["#000000", "#6B1705", "#D62D0A", "#E67205", "#00A5A5", "#388CF2"]
}, u = {
  light: S,
  dark: S
}, T = (t = !1, e = "light") => t ? u[e].bad2good : u[e].categorical, v = (t = ["blue"], e = "light") => {
  if (t.length === 0)
    return u[e].blue;
  if (t.length === 1)
    return u[e][t[0]];
  const n = [], i = {};
  return t.forEach((l) => {
    l in i ? i[l] += 1 : i[l] = 0, n.push(u[e][l][i[l]]);
  }), n;
}, o = {
  BAR: "BAR",
  COLUMN: "COLUMN",
  SCATTER: "SCATTER",
  DONUT: "DONUT",
  HEATMAP: "HEATMAP"
}, a = {
  color: "#38485C",
  fontFamily: "Inter",
  fontSize: "12px",
  fontWeight: 500,
  legendFontSize: "14px",
  legendFontWeight: 400,
  axisFontWeight: 400,
  tooltipBorderColor: "#00095B"
}, I = (t) => {
  const e = {};
  if (e.chart = $(
    t?.type || "",
    t?.variant || "",
    t?.series?.length || 1
  ), e.dataLabels = B(
    t?.labelFormatter,
    t?.type,
    t?.variant || "",
    t?.hideLabel
  ), e.colors = k(
    t?.type || "",
    t?.isCategorical,
    t?.colorPallete || ["blue"],
    t?.mode || "light"
  ), e.plotOptions = O(
    t?.type || "",
    t?.hideLabel,
    t?.variant || "",
    t?.colorScaleRanges || [],
    t?.dataLabels,
    t?.series?.length || 1
  ), t?.yAxis?.labels && (e.labels = t?.yAxis?.labels), e.legend = z(
    t?.legend,
    t?.type || "",
    t?.series || []
  ), t?.type !== o.DONUT && (e.grid = E(t?.gridType, t?.type || ""), e.xaxis = M(t?.xAxis, t?.type), e.yaxis = R(t?.yAxis, t?.type)), (t?.type === o.COLUMN || t?.type === o.BAR) && (t?.type === o.COLUMN && t?.variant === "default" && t?.series?.length > 1 ? e.stroke = {
    colors: ["transparent"],
    width: 4
  } : e.stroke = {
    colors: ["#fff"],
    width: 1
  }, t?.type === o.COLUMN && (t?.yAxis?.labelPrefix || t?.yAxis?.labelSuffix) && (e.yaxis.labels.formatter = function(n) {
    return `${t?.yAxis?.labelPrefix ?? ""}${n}${t?.yAxis?.labelSuffix ?? ""}`;
  })), (t?.type === o.COLUMN || t?.type === o.BAR) && (t?.type === o.COLUMN && t?.variant === "default" && t?.series?.length > 1 ? e.stroke = {
    colors: ["transparent"],
    width: 4
  } : e.stroke = {
    colors: ["#fff"],
    width: 1
  }), e.tooltip = L(t?.hideTooltip, t?.type || ""), e.fill = {
    opacity: 1
  }, t.type === o.SCATTER && !t?.xAxis?.max) {
    let n = 0;
    t.series.forEach((i) => {
      i.data.forEach((l) => {
        l[0] > n && (n = l[0]);
      });
    }), e.xaxis.max = n + 2;
  }
  return t?.type === o.DONUT && (e.labels = t.labels, e.responsive = [
    {
      breakpoint: 600,
      options: {
        legend: {
          position: "bottom"
        }
      }
    }
  ]), e;
}, $ = (t, e, n) => {
  const i = {};
  return i.toolbar = {
    show: !1
  }, i.fontFamily = a.fontFamily, t === o.COLUMN ? (n === 1 && (i.stacked = !0), e === "stacked" && (i.stacked = !0), e === "percentage" && (i.stacked = !0, i.stackType = "100%")) : t === o.BAR && (i.stacked = !0), i;
}, k = (t, e, n, i) => e ? T(!1, i) : v(n, i), B = (t, e, n, i) => {
  const l = {
    enabled: !1,
    enabledOnSeries: !1,
    textAnchor: "middle",
    style: {
      fontSize: a.fontSize,
      fontFamily: a.fontFamily,
      fontWeight: a.fontWeight
    },
    offsetX: 0,
    offsetY: 0
  };
  return t && (l.formatter = t), (e === o.BAR || e === o.COLUMN) && n === "percentage" && (l.enabled = !i), e === o.HEATMAP && (l.enabled = !i, l.formatter = function(f, r) {
    let s;
    return f >= 1e6 ? s = `${(f / 1e6).toFixed(1)}M` : f >= 1e4 ? s = `${Math.floor(f / 1e3)}k` : s = f, s;
  }), l;
}, E = (t, e) => {
  const n = {
    show: !0,
    borderColor: "#D1D5D9",
    strokeDashArray: 0,
    position: "back",
    xaxis: {
      lines: {
        show: !1
      }
    },
    yaxis: {
      lines: {
        show: !1
      }
    },
    row: {
      opacity: 0.3
    },
    column: {
      opacity: 0.3
    }
  };
  return (e === o.BAR || e === o.COLUMN) && (n.xaxis.lines.show = t === "xaxis" || t === "both", n.yaxis.lines.show = t === "yaxis" || t === "both"), e === o.SCATTER && (n.xaxis.lines.show = t === "xaxis" || t === "both", n.yaxis.lines.show = t === "yaxis" || t === "both"), n;
}, z = (t, e, n) => {
  const i = {
    position: t && t?.position,
    showTotal: t && t?.showTotal,
    title: t && t?.title,
    hide: t && t?.hide,
    indicatorShape: t && (e === o.HEATMAP ? t?.indicatorShape || "strap" : t?.indicatorShape || "square"),
    markerWidth: t && t?.markerWidth || 12,
    markerHeight: t && t?.markerHeight || 12,
    horizontalAlign: t && t?.horizontalAlign || "left",
    orientation: t && t?.orientation || "horizontal"
  };
  let l;
  (e === o.BAR || e === o.COLUMN || e === o.SCATTER) && i.orientation === "vertical" ? (n.length === 0 ? l = void 0 : n.length <= 3 ? l = 30 * n.length : l = 100, ["bottom", "top"].includes(i.position) || (l = void 0)) : e === o.DONUT && (n.length === 0 ? l = void 0 : l = 30 * (n.length + 1));
  const f = {
    show: !i.hide,
    height: l,
    showForSingleSeries: !i.hide,
    showForNullSeries: !i.hide,
    showForZeroSeries: !i.hide,
    position: i.position || "bottom",
    horizontalAlign: i.horizontalAlign || "left",
    orientation: i.orientation || "horizontal",
    fontSize: e === "HEATMAP" ? a.fontSize : a.legendFontSize,
    fontFamily: a.fontFamily,
    fontWeight: a.legendFontWeight,
    offsetX: 0,
    offsetY: 0,
    markers: {
      width: 12,
      height: 12,
      strokeColor: "#fff",
      radius: 0,
      offsetX: 0,
      offsetY: 0
    },
    itemMargin: {
      horizontal: i?.indicatorShape === "strap" ? 0 : 5,
      vertical: ["bottom", "top"].includes(i.position) ? 24 : 0
    }
  };
  return f.formatter = function(r, s) {
    if (e === o.DONUT) {
      let d = "";
      return s?.seriesIndex === s?.w?.config?.series?.length - 1 && i.showTotal && (d += `<div class="total-label">
                    <span class="total-text">Total</span>
                    <span class="legend-text">
                    ${s?.w?.config?.series?.reduce(
        (c, h) => c + h,
        0
      )}
                    </span>
                  </div>`), [
        '<div class="legend-item"><span class="legend-text">' + r + '</span><span class="legend-text">' + s.w.globals.series[s.seriesIndex] + "</span></div>",
        d
      ];
    } else if (i.orientation === "vertical" && (e === o.BAR || e === o.COLUMN)) {
      let d = "";
      return s?.seriesIndex === s?.w?.config?.series?.length - 1 && i.showTotal && (d += `
          <div class="total-label">
            <span class="total-text">Total</span>
            <span class="legend-text">
            ${s?.w?.config?.series?.reduce(
        (c, h) => c + h,
        0
      )}
            </span>
          </div>`), [
        '<div class="legend-item"><span class="legend-text">' + r + "</span></div>",
        d
      ];
    } else if (s?.seriesIndex === s?.w?.config?.series?.length - 1 && i.showTotal) {
      let d = i.position === "left" || i.position === "right" ? "<br />" : "";
      return d += s?.w?.config?.series?.length === 1 ? `<span style="font-weight: 500">Total: 
              ${s?.w?.config?.series[0]?.data?.reduce(
        (c, h) => c + h,
        0
      )}
            </span>` : "", [r, d];
    }
    return [r];
  }, i.indicatorShape === "circle" ? f.markers.radius = 12 : i.indicatorShape === "strap" && (f.markers = {
    width: i.markerWidth,
    height: i.markerHeight,
    radius: 0
  }), [o.BAR, o.COLUMN, o.SCATTER].includes(e) && (f.itemMargin.horizontal = 12, f.itemMargin.vertical = 4, f.offsetX = -16, (i.position === "bottom" || i.position === "top") && (f.offsetX = 12, f.offsetY = 10)), f;
}, M = (t, e) => {
  const n = {
    min: t && t?.min === 0 ? 0 : t?.min || void 0,
    max: t && t?.max || void 0,
    title: t && t?.title || "",
    tickInterval: t && t?.tickInterval || void 0,
    labels: t && t?.labels || void 0
  }, i = {
    categories: n?.labels || [],
    tickAmount: n?.tickInterval,
    min: n?.min,
    max: n?.max,
    decimalsInFloat: 0,
    position: "bottom",
    labels: {
      show: !0,
      rotate: -45,
      rotateAlways: !1,
      hideOverlappingLabels: !0,
      showDuplicates: !1,
      trim: !1,
      minHeight: void 0,
      maxHeight: 120,
      style: {
        fontSize: a.fontSize,
        fontFamily: a.fontFamily,
        fontWeight: a.axisFontWeight,
        cssClass: "apexcharts-xaxis-label"
      },
      offsetX: 0,
      offsetY: 0,
      datetimeUTC: !0,
      datetimeFormatter: {
        year: "yyyy",
        month: "MMM 'yy",
        day: "dd MMM",
        hour: "HH:mm"
      }
    },
    axisBorder: {
      show: e !== o.HEATMAP,
      color: "#4D5B6D",
      height: 1,
      width: "100%",
      offsetX: e === o.BAR ? -1 : 0,
      offsetY: e === o.SCATTER ? -1 : 0
    },
    axisTicks: {
      show: !1
    },
    title: {
      text: n?.title,
      offsetX: 0,
      offsetY: e === o.SCATTER ? -10 : 0,
      style: {
        fontSize: a.fontSize,
        fontFamily: a.fontFamily,
        fontWeight: a.fontWeight,
        cssClass: "apexcharts-xaxis-title"
      }
    },
    tooltip: {
      enabled: !1,
      formatter: void 0,
      offsetY: 0
    }
  };
  return e === o.SCATTER && (i.labels.formatter = function(l) {
    return parseFloat(l).toFixed(1);
  }), i;
}, R = (t, e) => {
  const n = {
    min: t && t?.min || void 0,
    max: t && t?.max || void 0,
    title: t && t?.title || "",
    tickInterval: t && t?.tickInterval || void 0,
    labels: t && t?.labels || void 0
  }, i = {
    show: !0,
    showForNullSeries: !0,
    tickAmount: n?.tickInterval,
    min: n?.min,
    max: n?.max,
    decimalsInFloat: 0,
    labels: {
      style: {
        fontSize: a.fontSize,
        fontFamily: a.fontFamily,
        fontWeight: a.axisFontWeight,
        cssClass: "apexcharts-xaxis-label"
      }
    },
    axisBorder: {
      show: e !== o.HEATMAP,
      color: "#4D5B6D",
      offsetX: 0,
      offsetY: e === o.SCATTER ? -2 : 0
    },
    axisTicks: {
      show: !1
    },
    title: {
      text: n?.title,
      rotate: -90,
      offsetX: 0,
      offsetY: 0,
      style: {
        fontSize: a.fontSize,
        fontFamily: a.fontFamily,
        fontWeight: a.fontWeight,
        cssClass: "apexcharts-yaxis-title"
      }
    },
    tooltip: {
      enabled: !1,
      offsetX: 0
    }
  };
  return e === o.BAR && (i.title.offsetX = 10), i;
}, O = (t, e, n, i, l, f) => {
  const r = {};
  return (t === o.BAR || t === o.COLUMN) && (r.bar = {
    horizontal: !0,
    columnWidth: "60%",
    barHeight: "70%",
    dataLabels: {
      position: "top",
      maxItems: 10,
      hideOverflowingLabels: !0,
      orientation: "vertical",
      total: {
        enabled: !e,
        formatter: void 0,
        offsetX: 0,
        offsetY: 0,
        style: {
          fontFamily: a.fontFamily
        }
      }
    }
  }, n === "percentage" && (r.bar.dataLabels.total.enabled = !1, r.bar.dataLabels.position = "center", r.bar.dataLabels.orientation = "horizontal", r.bar.columnWidth = "75%"), n === "default" && f > 1 && (r.bar.columnWidth = "80%"), t === o.COLUMN ? (r.bar.horizontal = !1, r.bar.dataLabels.total.offsetY = -10, n !== "percentage" && (r.bar.borderRadius = 4), r.bar.borderRadiusApplication = "end", r.bar.borderRadiusWhenStacked = "last") : t === o.BAR && (r.bar.dataLabels.total.offsetY = 7, r.bar.dataLabels.total.offsetX = 10, r.bar.borderRadius = 4, r.bar.borderRadiusApplication = "end", r.bar.borderRadiusWhenStacked = "last")), t === o.HEATMAP && (r.heatmap = {
    radius: 4,
    enableShades: !1,
    itemMargin: {
      horizontal: 50,
      vertical: 50
    },
    colorScale: {
      ranges: i
    }
  }), t === o.DONUT && (r.pie = {
    donut: {
      labels: {
        show: !0,
        total: {
          show: !0,
          showAlways: !l?.showHoverDataLabels || l?.dataLabel || l.dataValue,
          fontSize: "16px",
          fontFamily: a.fontFamily,
          fontWeight: a.fontWeight,
          formatter: function(s) {
            const c = s.globals.series.reduce(
              (A, w) => w += A
            );
            return l?.dataValue ? l.dataValue : c;
          }
        },
        name: {
          show: !0,
          offsetY: 30,
          formatter: (s) => l?.showHoverDataLabels && s !== "Total" ? s : l?.dataValue ? l.dataLabel : "Total",
          fontSize: "16px",
          fontStyle: a.fontFamily,
          fontWeight: a.fontWeight,
          color: a.color
        },
        value: {
          show: !0,
          fontSize: "40px",
          fontFamily: a.fontFamily,
          fontWeight: a.fontWeight,
          color: a.color,
          offsetY: -10
        }
      }
    },
    expandOnClick: !1
  }), r;
}, L = (t, e) => {
  const n = {
    enabled: !t,
    styles: {
      fontSize: a.fontSize,
      fontFamily: a.fontFamily
    },
    x: {
      show: !1
    },
    y: {
      formatter: function(i) {
        return typeof parseInt(i) == "number" && !Number.isInteger(parseInt(i)) ? i.toFixed(2) : i;
      }
    },
    custom: e === o.HEATMAP ? function({ series: i, seriesIndex: l, dataPointIndex: f, w: r }) {
      const s = r?.globals?.initialSeries[l]?.data[f], d = Object.keys(s), c = r?.config?.series[l]?.name;
      return `
              <span
                style="padding:10px 15px 0 15px;
                  color:#00142E;
                  font-family: ${g.inter};
                  font-size: ${x.small};
                  font-style: normal;
                  font-weight: ${b.body.medium};
                  line-height: ${y.medium};"
              >${c}</span>
              <ul
                style="list-style-type: none;
                  padding:0 15px;
                  color:  #38485C;
                  font-family: ${g.inter};
                  font-size: ${x.xsmall};
                  font-style: normal;
                  font-weight: ${b.body.regular};
                  line-height: ${y.small};"
              >
                ${d && d.map(
        (h) => `<li>${h.charAt(0).toUpperCase() + h.slice(1)}: ${s[h]} </li>`
      ).join("")?.replace(",", "")}
              </ul>`;
    } : void 0
  };
  return e === o.SCATTER && (n.custom = function({ seriesIndex: i, dataPointIndex: l, w: f }) {
    const r = f.config.series[i], s = f?.globals?.initialSeries[i]?.data[l];
    return `<div class="custom-tooltip" style="display:flex; justify-content:center; align-items: center;
                padding: ${p["1x"]} 10px; ">
                <div class="series-marker" style="background-color: ${f.config.colors[i]}; height: 12px; width: 12px; border-radius: ${m["3x"]}; margin-right: 10px;">
                </div>
                <div style="padding: 6px 0; display: flex; justify-content: center; align-items: center;
                font-size: ${x.xxsmall}; font-family: ${g.inter}; color:${a.color};">
                  <div class="series-name" style="margin-right: 5px;">
                    ${r.name}:
                  </div>
                  <div class="data-value" style=\`font-weight: ${b.headline};\`>
                    ${s[0]}, ${s[1]} 
                  </div>
                </div> 
              </div>`;
  }), n;
}, X = (t) => {
  const e = `
    .apexcharts-tooltip {
      border: ${C["1x"]} solid ${a.tooltipBorderColor} !important;
      color:${a.color};
    }
    .apexcharts-tooltip-series-group{
      padding-top: ${p["1x"]};
    }
  `, n = `
  .apexcharts-legend-series {
    display: flex !important;
    flex-direction: column !important;
    gap: ${p["1x"]} !important;
  }
  
  /* CSS styles for the first .apexcharts-legend-marker */
  .apexcharts-legend-series:first-of-type .apexcharts-legend-marker {
    border-top-left-radius: ${m["1x"]} !important;
    border-bottom-left-radius: ${m["1x"]} !important;
  }
  /* CSS styles for the last .apexcharts-legend-marker */
  .apexcharts-legend-series:last-of-type .apexcharts-legend-marker {
    border-top-right-radius: ${m["1x"]} !important;
    border-bottom-right-radius: ${m["1x"]} !important;
  }`;
  return {
    tooltipStyles: e,
    legendStrapStyle: n,
    legendStyles: (...r) => {
      const [s, d, c, h] = r;
      if ([o.BAR, o.COLUMN, o.SCATTER].includes(
        t.type
      ))
        return h ? `
                .apexcharts-legend {
                  flex-direction: ${d === "vertical" ? "column" : "unset"};
                  max-height: unset !important;
                  overflow: auto;
                  flex-wrap: ${d === "horizontal" && ["top", "bottom"].includes(c) ? "wrap !important" : "unset !important"};
                  justify-content: ${(() => d === "horizontal" ? s === "right" ? "flex-end" : s === "left" ? "flex-start" : "center" : "unset !important")()};
                  align-items: ${(() => {
          if (!["right", "left"].includes(c))
            return s === "right" ? "flex-end" : s === "left" ? "flex-start" : "center";
        })()};
                }
            ` : `
          .apexcharts-legend .apexcharts-legend-series { 
            display: flex !important;
            align-items: center !important;
            padding: ${p["1x"]};
            gap: 10px;
          
            .apexcharts-legend-text{
              padding-left: unset;
              margin-left: unset;
            }
          }
          .apexcharts-legend-marker {
            margin-right:unset;
          }
        `;
      if (t.type === o.DONUT)
        return `
        .apx-legend-position-right,
        .apx-legend-position-left {
          top: 0px !important;
          height: 100% !important;
          padding: 0px;
          width: 38% !important;
        }
        .apexcharts-legend.apexcharts-align-left .apexcharts-legend-series {
          display: inline-flex;
          align-items: flex-start;
          padding: ${p["1x"]};
          padding-left: ${p["2x"]};
        }
        .apexcharts-legend-text * {
          pointer-events: none;
          display: flex !important;
          /* gap: 10px; */
          justify-content: space-between !important;
          margin-left: 10px !important;
        }
        .apexcharts-legend-text {
          width: 100% !important;
          line-height: ${y.small};
        }
        .apexcharts-legend-marker {
          top: ${p["1x"]} !important;
        }
        .total-label {
          position: absolute;
          font-weight: 500;
          left: 0px;
          margin: 0px !important;
          padding-top: ${p["2x"]};
          width: 100%;
        }
        .total-text {
          margin-left: 0px !important;
        }

        @media ${F.mobile} {
          .apexcharts-legend.apexcharts-align-left .apexcharts-legend-series {
            display: flex;
          }
          .apexcharts-legend {
            display: block;
            width: 70%;
            margin: 0 auto;
        }
        }
      `;
    },
    legendLeftRightPositionStyle: `
    .apexcharts-legend.apx-legend-position-right {
        justify-content: center !important;
        margin-top: -50px !important;
    }
    
    .apexcharts-legend.apx-legend-position-left {
        justify-content: center !important;
        margin-top: -50px !important;
        left: 0 !important;
    }
    `,
    gridStyles: `
    .apexcharts-gridlines-vertical{
      :first-child {
        display: none;
      }
    }
  `
  };
};
export {
  o as C,
  X as a,
  I as c
};
